import { useEffect, useState } from 'react';

export default function useLoadScripts(urls) {
  const [loaded, setLoaded] = useState(false);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    if (!urls || urls.length === 0) {
      setLoaded(true);
      return;
    }

    let isCancelled = false;
    const errorList = [];

    const loadScript = (url) => {
      return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${url}"]`);

        if (existingScript) {
          // Already loaded or in progress
          if (existingScript.dataset.loaded === 'true') {
            resolve();
          } else {
            existingScript.addEventListener('load', () => resolve());
            existingScript.addEventListener('error', () => {
              errorList.push(url);
              resolve(); // still resolve to continue
            });
          }
          return;
        }

        const script = document.createElement('script');
        script.src = url;
        script.async = true;

        script.onload = () => {
          script.dataset.loaded = 'true';
          resolve();
        };

        script.onerror = () => {
          errorList.push(url);
          resolve(); // still resolve to proceed
        };

        document.head.appendChild(script);
      });
    };

    Promise.all(urls.map(loadScript)).then(() => {
      if (!isCancelled) {
        setErrors(errorList);
        setLoaded(true);
      }
    });

    return () => {
      isCancelled = true;
    };
  }, [urls]);

  return { loaded, errors };
}